import { storiesOf } from '@storybook/vue';
import { withKnobs, boolean, color, text } from '@storybook/addon-knobs';
import { EventBus } from '@/main/eventBus';
import { PageMode } from '@/main/utils/pageMode';

const stories = storiesOf('Components/DMS/Form', module);

stories
	.addDecorator(withKnobs)
	.add('Switch', () => ({
		template: '<dms-switch v-bind="$props" />',
		props: {
			value: {
				default: boolean('Aktivní', true),
			},
			label: {
				default: text('Label', undefined),
			},
			active: {
				default: text('Text (aktivní)', 'Zapnuto'),
			},
			inactive: {
				default: text('Text (neaktivní)', 'Vypnuto'),
			},
			activeColor: {
				default: color('Barva (aktivní)', undefined),
			},
			inactiveColor: {
				default: color('Barva (neaktivní)', undefined),
			},
			disabled: {
				default: boolean('Disabled', false),
			},
		},
		mounted() {
			EventBus.$emit('Mode', PageMode.EDIT);
		},
	}));
